import {useState} from 'react';
import DeleteConfirmDialog from '~/components/DeleteConfirmDialog';
import {DeleteIcon} from '~/assets/svgs';
import {FinancialRecordData} from './types';
import {useDeleteInsuranceClaim} from '../InsuranceClaims/hooks';
import {useDeleteFinancialRecord} from '../PaymentList/hooks';
import {FinanceRecordType} from './types';

interface FinancialRecordActionHandlerProps {
  rowData: FinancialRecordData;
  recordType: FinanceRecordType;
}

const FinancialRecordActionHandler = ({
  rowData,
  recordType,
}: FinancialRecordActionHandlerProps) => {
  const {
    sendDeleteInsuranceClaimRequest,
    isDeleting: isDeletingInsuranceClaim,
  } = useDeleteInsuranceClaim();
  const {isPending: isDeletingFinancialRecord, requestDeleteAppointment} =
    useDeleteFinancialRecord();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const isDeleting =
    recordType === 'insurance-claim'
      ? isDeletingInsuranceClaim
      : isDeletingFinancialRecord;

  const handleDeleteClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    setIsModalOpen(true);
  };

  const handleOnDelete = async () => {
    try {
      if (recordType === 'insurance-claim') {
        sendDeleteInsuranceClaimRequest(rowData.id.toString());
      } else {
        requestDeleteAppointment(rowData.id);
      }
      setIsModalOpen(false);
    } catch (error) {
      console.error(
        `Error deleting ${recordType === 'insurance-claim' ? 'insurance claim' : 'financial record'}:`,
        error
      );
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div onClick={e => e.stopPropagation()}>
      <DeleteIcon
        className="mr-4 cursor-pointer hover:opacity-70"
        onClick={handleDeleteClick}
      />
      {isModalOpen && (
        <DeleteConfirmDialog
          onClose={handleCloseModal}
          isDisabled={isDeleting}
          isOpen={isModalOpen}
          onDelete={handleOnDelete}
          title={
            recordType === 'insurance-claim'
              ? 'insurance claim'
              : 'financial record'
          }
          className="custom-delete-dialog"
        />
      )}
    </div>
  );
};

export default FinancialRecordActionHandler;
